// extracted by mini-css-extract-plugin
export default {"CatalogPreviewModal":"_1Sp5Wi4-Mec6B66bNW-_ib"};